<template>
  <div class="translate_content">
    <div class="images_list" :style="{ transform: 'translateX(' + currentPosition + 'px)'}" @mouseenter="isPaused=true" @mouseleave="isPaused=false">
      <div v-for="(item, index) in list" :key="index" class="image-item"
        :style="{ 'backgroundImage': 'url(' + item + ')' }" @click="triggerAction(index)"></div>
        <div v-for="(item, index) in list" :key="index+'1'" class="image-item"
        :style="{ 'backgroundImage': 'url(' + item + ')' }" @click="triggerAction(index)"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list'],
  data: () => {
    return {
      currentPosition: 0,
      animationId: null,
      lastTimestamp: 0,
      speed: 100,
      isPaused: false,
      itemWidth: 276 // 300px宽度 + 20px间距
    };
  },
  created() {
    this.$nextTick(() => {
      this.animationId = requestAnimationFrame(this.animate);
    });
  },

  methods: {
    animate(timestamp) {
      if (!this.lastTimestamp) this.lastTimestamp = timestamp;
      const deltaTime = timestamp - this.lastTimestamp;
      this.lastTimestamp = timestamp;

      if (!this.isPaused) {
        // 计算移动距离
        const deltaX = (this.speed * deltaTime) / 1000;
        this.currentPosition -= deltaX;

        // 检查是否需要重置位置
        if (this.currentPosition <= -276 * this.list.length) {
          this.currentPosition += this.itemWidth * this.list.length;
        }
      }
      this.animationId = requestAnimationFrame(this.animate);
    },
    triggerAction(item) {
      this.$emit('action', item);
    }
  }
};
</script>
<style scoped>
.translate_content {
  width: 1200px;
  height: 173px;
  position: relative;
  overflow: hidden;
  margin: 0px auto;
}

.images_list {
  display: flex;
  position: absolute;
  height: 100%;
  will-change: transform;
  /* 优化动画性能 */
}

.image-item {
  width: 261px;
  height: 100%;
  flex-shrink: 0;
  margin-right: 20px;
  background-size: cover;
  background-position: center;
  cursor: pointer;
}
</style>
